<template>
  <div>
    <v-row class="mb-6">
      <v-col>
<!--        <span class="header bold grey&#45;&#45;text">{{ $t('membership.headerContent') }}</span>-->
        <span class="header bold grey--text" v-html="membership[`description_${lang}`]"/>
      </v-col>
    </v-row>
    <v-row class="mb-6">
      <template v-for="(item, index) of serviceTopic">
        <v-col :key="index.toString()" cols="12" md="5" class="my-6">
          <div class="sub-header2 text-tcdc-green bold mb-4"><img src="../../assets/icons/services/membership.png" class="eventdetail-card-logo mr-2" width="30"/>{{ item[`title_${lang}`] }}</div>
          <div class="vhtml" v-html="item[`content_${lang}`]"></div>
        </v-col>
      </template>
    </v-row>
    <v-row class="mb-12">
      <v-col cols="9" sm="6" md="4" lg="3">
        <GreenButton v-if="!membership['disable_register_button_branch_id'].includes(branchId)" :label="$t('membership.joinMember')" @onPress="joinTcdc()" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <MemberExpandable :items="serviceList" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GreenLabel from "../../components/labels/GreenLabel";
import MemberExpandable from "../../components/expandables/MemberExpandable";
import {mapState} from "vuex";
import GreenButton from "../buttons/GreenButton";

export default {
  components: {
    GreenButton,
    // GreenLabel,
    MemberExpandable
  },
  props: {},
  computed:{
    ...mapState({
      lang: state => state.Branch.lang,
      branchId: state => state.Branch.branch_id,
      membership : state=>{
        return state.ServiceMenu.membership_main;
      },
      serviceTopic : state=>{
        return [
          ...state.ServiceMenu.membership.map(membership=>({
            title_th : membership.title_th,
            title_en : membership.title_en,
            content_th : membership.description_th,
            content_en : membership.description_en,
          }))
        ]
      }
    }),
  },
  methods: {
    joinTcdc() {
      window.open('https://my.tcdc.or.th/signup');
    }
  },
  data: () => ({
    serviceList: [
      {
        id: "999",
        title_th: "คุณสมบัติและหลักฐานการสมัคร",
        title_en: "tcdc member",
        layout: "2"
      },
      {
        id: "998",
        title_th: "อัตราค่าสมาชิกและวิธีการชำระเงิน",
        title_en: "member rate",
        layout: "3"
      },
      {
        id: "997",
        title_th: "สิทธิประโยชน์ของสมาชิก",
        title_en: "member benefit",
        layout: "4"
      }
    ]
  })
};
</script>

<style></style>
